export default "__VITE_ASSET__C2T36LXF__"